import { render, staticRenderFns } from "./FloorEditPage.vue?vue&type=template&id=2f62b62f&"
import script from "./FloorEditPage.vue?vue&type=script&lang=ts&"
export * from "./FloorEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports